import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import PartnerCalendar from "@/pages/partner/Calendar";

export default function ClienteCalendar() {
  const { user } = useAuth();
  if (user?.client?.billing_mode === "slot") return <Navigate to="/cliente" replace />;
  return <PartnerCalendar endpoint="/cliente/editions" base="/cliente/corsi" />;
}
